import React, { ForwardedRef, forwardRef } from 'react'
import { AutoCompleteProps, InputRef } from 'antd'
import cl from 'classnames'

import AutoComplete from 'Shared/atoms/AutoComplete'
import Icon from 'Shared/atoms/Icon'
import Input from 'Shared/atoms/Input'
import { withTooltip } from 'Shared/HOCs/withTooltip'
import IconButton from 'Shared/molecules/IconButton'
import { normalizeSearchText } from 'Shared/utils/string'

import styles from './styles.module.scss'

const AutoCompleteWithTooltip = withTooltip(AutoComplete)

type SearchAutocompleteProps = AutoCompleteProps & {
	placeholderText?: string
	classNameInput?: string
	showTooltip?: boolean
	isStaticWidth?: boolean
}

const SearchAutocomplete = forwardRef(
	(
		{
			className,
			classNameInput,
			placeholderText,
			allowClear,
			isStaticWidth,
			value,
			...rest
		}: SearchAutocompleteProps,
		ref: ForwardedRef<InputRef | null>
	) => {
		const valueProps = value === undefined ? {} : { value: normalizeSearchText(value) }

		return (
			<AutoCompleteWithTooltip
				{...rest}
				{...valueProps}
				className={cl(styles.searchAutocomplete, className, {
					[styles.staticWidth]: isStaticWidth
				})}
				popupMatchSelectWidth={false}
				tooltipText={placeholderText}
				allowClear={
					allowClear && {
						clearIcon: (
							<IconButton className={styles.closeButton} iconType="closeCircle" />
						)
					}
				}
			>
				<Input
					ref={ref}
					className={classNameInput}
					prefix={<Icon type={'search'} />}
					placeholder={placeholderText}
				/>
			</AutoCompleteWithTooltip>
		)
	}
)
export default SearchAutocomplete
